import { guestStore } from "./store";
import { StorefrontModule } from "@lib/appRegister";

export const GuestModule: StorefrontModule = async function ({ store }) {
  store.registerModule("guest", guestStore);
  await store.dispatch("guest/load");
};
